import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SubscriptionBlur.css';

const SubscriptionBlur = ({ children, isLocked = false }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    navigate('/pricing');
  };

  if (!isLocked) {
    return <>{children}</>;
  }

  return (
    <div className="subscription-blur-wrapper">
      {children}
      <div className="subscription-blur-overlay">
        <button
          type="button"
          className="subscription-upgrade-btn"
          onClick={handleUpgrade}
        >
          Upgrade
        </button>
      </div>
    </div>
  );
};

export default SubscriptionBlur;
